import React from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import "./ExternalApiModal.scss";

export const ExternalApiSecretModal = ({ apiKey, onClose, t }) => (
  <Modal
    show={Boolean(apiKey)}
    onHide={onClose}
    backdrop="static"
    keyboard={false}
    centered
    dialogClassName="external-api-modal"
    aria-labelledby="external-api-secret-title"
    aria-describedby="external-api-secret-warning"
  >
    <Modal.Header>
      <Modal.Title id="external-api-secret-title">{t("developer-api-save-key-title")}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Alert variant="warning" id="external-api-secret-warning" className="external-api-modal__warning">
        {t("developer-api-save-key-warning")}
      </Alert>
      <Form.Control
        readOnly
        value={apiKey}
        className="external-api-secret"
        aria-label={t("developer-api-key-label")}
      />
    </Modal.Body>
    <Modal.Footer>
      <Button
        variant="light"
        className="external-api-modal__button"
        onClick={() => {
          copy(apiKey);
          toast.success(t("developer-api-copy-success"));
        }}
      >
        <i className="far fa-copy" aria-hidden="true" />
        {t("developer-api-copy-key")}
      </Button>
      <Button variant="primary" className="external-api-modal__button external-api-modal__button--confirm" onClick={onClose}>
        <i className="fas fa-check" aria-hidden="true" />
        {t("developer-api-saved-key")}
      </Button>
    </Modal.Footer>
  </Modal>
);

export const ExternalApiRevokeModal = ({ busy, show, onCancel, onConfirm, t }) => (
  <Modal
    show={show}
    onHide={busy ? undefined : onCancel}
    backdrop={busy ? "static" : true}
    keyboard={!busy}
    centered
    dialogClassName="external-api-modal"
    aria-labelledby="external-api-revoke-title"
    aria-describedby="external-api-revoke-warning"
  >
    <Modal.Header closeButton={!busy} closeLabel={t("close")}>
      <Modal.Title id="external-api-revoke-title">{t("developer-api-revoke-title")}</Modal.Title>
    </Modal.Header>
    <Modal.Body aria-busy={busy}>
      <p id="external-api-revoke-warning" className="external-api-modal__message">{t("developer-api-revoke-warning")}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="light" className="external-api-modal__button" disabled={busy} onClick={onCancel}>
        {t("cancel")}
      </Button>
      <Button
        variant="danger"
        className="external-api-modal__button external-api-modal__button--danger"
        disabled={busy}
        onClick={onConfirm}
      >
        <i className="fas fa-trash-alt" aria-hidden="true" />
        {t("developer-api-revoke-key")}
      </Button>
    </Modal.Footer>
  </Modal>
);
